import { render, staticRenderFns } from "./support-needs-form.vue?vue&type=template&id=d35da4fc&scoped=true"
import script from "./support-needs-form.vue?vue&type=script&lang=js"
export * from "./support-needs-form.vue?vue&type=script&lang=js"
import style0 from "./support-needs-form.vue?vue&type=style&index=0&id=d35da4fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35da4fc",
  null
  
)

export default component.exports